

























import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class CheckField extends Vue {
  @Prop({ type: Object, required: true }) row!: { [key: string]: string[] };
  @Prop({ type: String }) tip!: string;
  @Prop({ type: Function }) onClick!: Function;
  //Editable?
  @Prop({ type: Boolean, default: false }) isDisabled!: boolean;
  @Prop({ type: Boolean }) isComponentError!: boolean;

  handleClick() {
    if (this.onClick) {
      this.onClick(this.tip);
    }
  }

}
